import Link from './link';
import ActionLink from './link-components/action-link';
import BlackLink from './link-components/black-link';
import LoadingLink from './link-components/loading-link';

export { ActionLink, BlackLink, LoadingLink };
export default Link;
